module.exports = __webpack_public_path__ + "static/media/X.7f243c0f.svg";